import { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { displayError } from '../../helpers';
import { getAllDeliveryChallans, reactivateDeliveryChallan } from '../../services/DeliveryChallanServices';
import ReactTablePopUpSubmitWrapper from '../../components/ReactTablePopUpSubmitWrapper';
import { CANCELLED_DC_COLUMNS, mapCancelledDcRow } from './cancelledDcUtils';
import { formatQty, isInactiveRecord, sumField } from '../../utils/listSummaryUtils';

function CancelledDcModal({ open, onClose, cookies, fromDate, uptoDate, onReactivated }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);

  const loadCancelled = useCallback(() => {
    if (!open || !cookies?.myToken) return;
    setLoading(true);
    getAllDeliveryChallans(cookies, {
      from_date: fromDate,
      upto_date: uptoDate,
      record_statuses: 'false',
    })
      .then((response) => {
        const cancelled = (response?.delivery_challan_list || [])
          .filter((dc) => isInactiveRecord(dc))
          .map(mapCancelledDcRow);
        setRecords(cancelled);
      })
      .catch((error) => {
        displayError(error?.response?.data ?? error?.message, 'Failed to load cancelled delivery challans');
        setRecords([]);
      })
      .finally(() => setLoading(false));
  }, [cookies, open, fromDate, uptoDate]);

  useEffect(() => {
    loadCancelled();
  }, [loadCancelled]);

  useEffect(() => {
    if (!open || typeof document === 'undefined') return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const totalQty = formatQty(sumField(records, 'dc_qty'));

  const handleReactivate = (rowId) => {
    const row = records.find((item) => String(item.id) === String(rowId));
    if (!row) return;

    Swal.fire({
      title: 'Reactivate Delivery Challan?',
      html: `<div style="text-align:left;font-size:14px;">
        <div><b>DC No:</b> ${row.delivery_challan_no || '-'}</div>
        <div><b>Date:</b> ${row.delivery_challan_date || '-'}</div>
        <div><b>Qty:</b> ${row.dc_qty || '0.00'}</div>
      </div>`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Reactivate',
      cancelButtonText: 'No',
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoading(true);
      reactivateDeliveryChallan(cookies, row.id)
        .then(() => {
          Swal.fire('Reactivated', '', 'success');
          loadCancelled();
          onReactivated?.();
        })
        .catch((error) => {
          displayError(error?.response?.data ?? error?.message, 'Reactivate Failed');
          setLoading(false);
        });
    });
  };

  return (
    <div className="modal" tabIndex="-1" style={{ display: 'block' }}>
      <div className="modal-dialog modal-xl" style={{ height: '560px' }}>
        <div className="modal-content">
          <div className="modal-body display">
            <div className="container item-list-table-container">
              <ReactTablePopUpSubmitWrapper
                title={`Cancelled Delivery Challans (${records.length} | Qty ${totalQty}) — click ✓ to reactivate`}
                columns={CANCELLED_DC_COLUMNS}
                data={records}
                onRowSubmit={handleReactivate}
                onClose={onClose}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CancelledDcModal;
